import React from "react";
import { ShieldCheck, BadgeCheck, Wallet, Truck, RotateCcw, Lock, Gift, Headset, Store } from "lucide-react";

const NAVY = "#1B1F5C";
const iconMap = { ShieldCheck, BadgeCheck, Wallet, Truck, RotateCcw, Lock, Gift, Headset, Store };

const TrustStrip = ({ items }) => (
  <section className="py-6 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <div className="bg-[#F5F6FA] rounded-2xl px-6 py-5 grid grid-cols-2 md:grid-cols-3 lg:flex lg:items-center lg:justify-between gap-4">
        {items.map((it) => {
          const Icon = iconMap[it.icon] || ShieldCheck;
          return (
            <div key={it.title} className="flex items-center gap-3">
              <span className="h-11 w-11 rounded-full border-2 flex items-center justify-center shrink-0" style={{ borderColor: "#D8DBEA" }}>
                <Icon size={20} style={{ color: NAVY }} strokeWidth={1.8} />
              </span>
              <div className="text-left leading-tight">
                <p className="text-[12.5px] font-extrabold" style={{ color: NAVY }}>{it.title}</p>
                <p className="text-[11.5px] font-semibold text-gray-500">{it.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default TrustStrip;
